// 2026-09-21 - FormuLearning - 프로젝트 목록 정렬 선택 (이슈 #77 G6, COMP-PROJECT-SORT-CONTROL)
// 파일 위치: frontend/src/features/project/ProjectSortControl.tsx
// BR-PRJ-04 — Name·Created·Modified × 정순·역순, 기본 Modified 역순. Modified = 내부데이터
// 최종 수정일(BR-PRJ-03). 선택 보존은 호출부(ProjectExplorer)가 한다.

import Popover from '../../components/common/Popover'
import { SORT_LABELS, type SortKey, type SortState } from './folderTree'

interface Props {
  sort: SortState
  onChange: (sort: SortState) => void
}

const KEYS: SortKey[] = ['modified', 'created', 'name']
const HINT: Record<SortKey, string> = {
  modified: 'Last change to step data',
  created: 'Project creation date',
  name: 'Alphabetical',
}

export default function ProjectSortControl({ sort, onChange }: Props) {
  const arrow = sort.dir === 'asc' ? '↑' : '↓'
  return (
    <Popover
      label="Sort projects"
      width={188}
      trigger={
        <span
          data-testid="project-sort-trigger"
          className="rounded px-1 py-0.5 text-[10px] text-text-secondary transition-colors hover:bg-bg-input hover:text-text-body"
          title="Sort projects"
        >
          {SORT_LABELS[sort.key]} {arrow}
        </span>
      }
    >
      {(close) => (
        <div role="menu" aria-label="Sort projects" className="space-y-0.5">
          {KEYS.map((key) => (
            <button
              key={key}
              type="button"
              role="menuitemradio"
              aria-checked={sort.key === key}
              onClick={() => {
                onChange({ ...sort, key })
                close()
              }}
              className="flex w-full items-center gap-2 rounded px-2 py-1 text-left hover:bg-bg-input"
            >
              <span className="w-3 text-accent-purple">{sort.key === key ? '●' : ''}</span>
              <span className="flex-1">
                <span className="block text-[11px] text-text-body">{SORT_LABELS[key]}</span>
                <span className="block text-[9px] text-text-muted">{HINT[key]}</span>
              </span>
            </button>
          ))}
          <div className="my-1 border-t" style={{ borderColor: 'var(--border-subtle)' }} />
          <div className="flex gap-1 px-1">
            {(['asc', 'desc'] as const).map((dir) => (
              <button
                key={dir}
                type="button"
                role="menuitemradio"
                aria-checked={sort.dir === dir}
                onClick={() => {
                  onChange({ ...sort, dir })
                  close()
                }}
                className="flex-1 rounded px-2 py-1 text-[10px] transition-colors hover:bg-bg-input"
                style={sort.dir === dir ? { background: 'var(--bg-chip-purple)', color: 'var(--color-text-body)' } : undefined}
              >
                {dir === 'asc' ? '↑ Ascending' : '↓ Descending'}
              </button>
            ))}
          </div>
        </div>
      )}
    </Popover>
  )
}
